




import { Component, Vue } from 'vue-property-decorator';
import AttendanceReview from '@/components/attendance/AttendanceReview.vue';

@Component(({
    components: {
        AttendanceReview,
    },
}))

export default class RegularizationReview extends Vue {
}
